const choiceLetter = (index: number): string =>
  index < 26 ? String.fromCharCode(65 + index) : String(index + 1);

export const choiceImageUrl = (choice: unknown): string =>
  choice && typeof choice === "object"
    ? String((choice as { imageUrl?: string }).imageUrl || "")
    : "";

export function choiceImage(
  choice: unknown,
  index: number,
): HTMLImageElement | null {
  const url = choiceImageUrl(choice);
  if (!url) return null;
  const img = document.createElement("img");
  img.src = url;
  img.alt = `Option ${choiceLetter(index)}`;
  img.className = "et-choice-image";
  return img;
}

export const choiceLabel = (choice: unknown): string => {
  if (choice && typeof choice === "object") {
    const record = choice as {
      text?: string;
      value?: unknown;
      imageUrl?: string;
      hasText?: boolean;
    };
    if (choiceImageUrl(choice) && record.hasText === false) return "";
    return String(record.text ?? record.value ?? "");
  }
  return String(choice ?? "");
};

export function paintChoice(
  target: HTMLElement,
  image: HTMLImageElement | null,
  text: string,
  render: (el: HTMLElement, value: string) => void,
): void {
  if (image) target.appendChild(image);
  if (!text) return;
  const body = image
    ? target.appendChild(document.createElement("span"))
    : target;
  render(body, text);
}
